var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('div',{staticClass:"d-flex cursorPointer"},[_c('app-icon',{staticClass:"editIcon-container",class:hover || _vm.isActive ? 'orange' : 'appWhite',attrs:{"color":hover || _vm.isActive ? 'appWhite' : 'orange',"icon":"edit","size":"32","title":"Edit"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }